import { ListItem, ListItemText } from "@mui/material";
import { PaperCard } from "../../../../shared/ui/paper-card/paper-card.component";
import CarListItemComponent from "./car-list-item.component";
import { CarWithCostumer } from "../../../../entities/car/model/car";

interface CarsListComponentProps {
  props: {
    cars: CarWithCostumer[];
  };
}

export const CarsListComponent = ({ props }: CarsListComponentProps) => {
  const { cars } = props;
  console.log("Rendering CarsListComponent with cars:", cars);

  return (
    <PaperCard title={`Lista - mostrando ${cars.length} carro(s) encontrado(s)`}>
      <ListItem
        divider
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-end",
          textAlign: "center",
          marginTop: "2rem"
        }}
      >
        {["CLIENTE", "MARCA", "MODELO", "PLACA", "CHASSI", "CRIADO"].map((item, idx) => (
          <ListItemText id={`car-list-header-${item}`} primary={item} sx={{ flex: "1", fontWeight: "bold" }} key={item} />
        ))}
      </ListItem>
      {cars.map((car) => (
        <CarListItemComponent car={car} key={car.id} />
      ))}
    </PaperCard>
  );
};

export default CarsListComponent;
